import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { addWatermark, cleanBase64 } from '../utils';
import { getUser } from '~src/user';
import Swal from 'sweetalert2';
import JSZip from 'jszip';
import { getSelectedPagesByUser } from './getSelectedPagesByUser';
import {
  getSelectedPageImage,
  saveSelectedPageImage,
} from './saveSelectedPageImage';
import { saveAs } from 'file-saver';

export const savePNG = async () => {
  const metadata = getMetadata();
  const { user } = await getUser();
  const selectedPagesByUser = getSelectedPagesByUser();

  const fileName = slugify(
    `${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }`
  );

  const numberOfPages = selectedPagesByUser.length;

  if (numberOfPages === 1) {
    await saveSelectedPageImage({
      page: selectedPagesByUser[0],
      imageFormat: 'png',
      fileName: fileName + '.png',
      withWatermark: user.org_pointer.tipo_istanza === 'demo',
    });
    return;
  }

  // Ogni pagina si genera a piena risoluzione: con più pagine servono alcuni
  // secondi.
  Swal.fire({
    text: 'Sto generando la cartella zip...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const zip = new JSZip();
  const folder = zip.folder('Cartella ' + fileName);

  let content;
  try {
    let pageNumber = 0;
    for (let page of selectedPagesByUser) {
      pageNumber++;

      // Come il PNG di una sola pagina: getImageFromPage restituisce un JPEG,
      // che nello zip diventerebbe un .png senza trasparenza e senza DPI.
      let image = await getSelectedPageImage(page, 'png');

      if (user.org_pointer.tipo_istanza === 'demo') {
        image = await addWatermark(image);
      }

      folder.file(`Pagina ${pageNumber}.png`, cleanBase64(image).base64, {
        base64: true,
      });
    }
    content = await zip.generateAsync({ type: 'blob' });
  } catch (error) {
    // Il caricamento non si può chiudere a mano: resterebbe sopra l'editor.
    Swal.close();
    throw error;
  }

  saveAs(content, fileName + '.zip');
  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: 'La cartella zip &egrave; stata scaricata.',
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};
